import { render, staticRenderFns } from "./req-item-review.vue?vue&type=template&id=0193f531&scoped=true"
import script from "./req-item-review.vue?vue&type=script&lang=js"
export * from "./req-item-review.vue?vue&type=script&lang=js"
import style0 from "./req-item-review.vue?vue&type=style&index=0&id=0193f531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0193f531",
  null
  
)

export default component.exports